export enum LogoSize {
  LARGE = 'lg',
}
